<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g ref="main">
        <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/fin/Fin-480w.jpg`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/fin/Fin-768w.jpg`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/fin/Fin-1280w.jpg`" media="(max-width: 1280px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/fin/Fin.jpg`" />
          </picture>
        </foreignObject>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.4"
      :tx=".2" :ty="0.5"
      :fontSize="56"
      :className="`minion text-center italic`"
      :bg="`transparent`"
      :styles="{lineHeight: `1em`}">
      T’áá Ákódí
      <br>
      <span style='font-size: 0.75em; font-style: normal; font-weight: 700'>“That’s It”</span>
    </SceneDialogue>
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const { main, cta } = this.$refs
    const d = this.$refs["dialogue"].$el
    TweenLite.set(main, {opacity: 0})
    TweenLite.set(d, {opacity: 0})
    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 2, {opacity: 1}), 0.5)
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()},
    touchRestart(e) {
      e.preventDefault()
      e.stopPropagation()
      this.restart()
    },
    restart(e) {
      this.$router.push("/")
    }
  }
}
</script>

<style lang="scss" scoped>
.cta {
  cursor: pointer;
  #cta-clip rect {
    transform: scaleX(0);
    transform-origin: 1503px 0px;
    transition: transform 0.4s ease; }
  &:hover {
    #cta-clip rect {
      transform-origin: 0px 0px;
      transform: scaleX(1); }
  }
}
</style>
